'use client';

import { useMemo } from 'react';
import { useParams, useSearchParams } from 'next/navigation';
import { HyperLink } from '@/components/publicSearch/resultCell/HyperLink';
import { buildSocietySearchHref } from '@/lib/publicSearchPaths';
import { SEARCH_PARAM } from '@/constants/searchParams';
import { SEARCH_TYPE } from '@/constants/searchType';
import type { GetSalesRow } from '../constants';
import { SaleResultsLabel } from './SaleResultsLabel';

export function SaleCatalogueNameLink({ row }: { row: GetSalesRow }) {
  const params = useParams<{ orgName: string }>();
  const searchParams = useSearchParams();

  const href = useMemo(() => {
    const org = params.orgName ?? '';
    if (!org) return '#';
    const q = new URLSearchParams(searchParams.toString());
    q.delete(SEARCH_PARAM.SEARCH_TYPE);
    q.set(SEARCH_PARAM.SALE_ID, String(row.ID));
    return buildSocietySearchHref(
      org,
      SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS,
      q,
    );
  }, [params.orgName, searchParams, row.ID]);

  return (
    <>
      <HyperLink label={row.SALE_NAME} pathname={href} />
      <SaleResultsLabel saleType={row.SALE_TYPE} saleName={row.SALE_NAME} />
    </>
  );
}
